import { useCallback, useState } from 'react';

/**
 * Disclosure state for the dimension rubric dialog.
 *
 * The page that renders a grid of DimensionCards owns which dimension's rubric
 * is open, so a single shared <DimensionRubricDialog> can step through the whole
 * ordered dimension list (prev/next) without closing between dimensions.
 * `openRubric` doubles as the navigate handler — it just points the dialog at a
 * different dimension.
 */
export function useRubricDisclosure() {
  const [activeDimension, setActiveDimension] = useState<string | null>(null);
  const openRubric = useCallback((dimension: string) => setActiveDimension(dimension), []);
  const closeRubric = useCallback(() => setActiveDimension(null), []);
  return { activeDimension, openRubric, closeRubric };
}
